import { Injectable } from '@angular/core';
import { SucursalApi } from '../../services/lbsdk/services/custom/Sucursal';
import { LoopBackFilter } from '../../services/lbsdk';
import { Sucursal } from '../../services/lbsdk/models/Sucursal';
import { Observable } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Injectable()
export class CompaniesProvider {

  constructor(private companyApi: SucursalApi,private authService: AuthService) {
    console.log('Hello CompaniesProvider Provider');
  }

  find(filter) {
    return this.companyApi.find(filter)
  }

  getOne(id: number): Observable<Sucursal> {
    let filter: any = { where: { id: id } };
    return this.companyApi.findOne(filter);
  }

  getById(id: number): Observable<Sucursal> {
    return this.companyApi.findById(id);
  }

  create(data: Sucursal): Observable<Sucursal> {
    return this.companyApi.create(data);
  }

  update(data: Sucursal): Observable<Sucursal> {
    return this.companyApi.patchAttributes(data.idsucursal, data);
  }

  delete(data: Sucursal): Observable<Sucursal> {
    return this.companyApi.deleteById(data.idsucursal);
  }
  
  count(filter) {
    return this.companyApi.count(filter)
  }

  
}



// WEBPACK FOOTER //
// ./src/providers/companies/companies.provider.ts